export default ".cls-1[data-v-fafaefa6]{fill:var(--primary-color)}"